import ErrorBoundary from "@/components/ErrorBoundary/errorBoundary.component";
import SingleLineTimer from "@/components/SingleLineTimer/singleLineTimer.component";
import SingleLineTimerMobile from "@/components/SingleLineTimer/singleLineTimerMobile.component";
import { useMediaQuery } from "@/hooks/AppContext/mediaQuery";
import { Button } from "@/shadcn/components/ui/button";
import { OrganizedTimersEvent } from "@/types";
import { formatElapsedTime, totalElapsedTime } from "@/utils/utils";
import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";

type ToggleTimerProps = {
  type: "Today" | "This Week" | "No Events" | (string & {});
  timers: OrganizedTimersEvent[];
};

const ToggleTimer: React.FC<ToggleTimerProps> = ({ type, timers }) => {
  const [showRows, setShowRows] = useState<boolean>(type === "Today");
  const isNotSmall = useMediaQuery("sm");

  function sortTimers(a: OrganizedTimersEvent, b: OrganizedTimersEvent) {
    return (
      new Date(b.event_start).getTime() - new Date(a.event_start).getTime()
    );
  }

  return (
    <>
      <Button
        variant="ghost"
        className="px-1 py-1 my-1 h-auto w-full justify-start"
        onClick={() => {
          setShowRows(!showRows);
        }}
      >
        {type} {formatElapsedTime(totalElapsedTime(timers))}
        {/* {tasks.length > 0 ? " : " + tasks.length : ""} */}
      </Button>
      {!showRows && <hr />}
      <AnimatePresence>
        {showRows && (
          <motion.div
            key={timers.map((timer) => timer.timer.id).join(",")}
            initial={{ opacity: 0, y: -25 }}
            animate={{ opacity: 1, y: 0 }}
            className="w-full overflow-hidden"
          >
            {timers.length === 0 ? (
              <div className="p-2 select-none">No Timers</div>
            ) : (
              timers.sort(sortTimers).map((timer, index) => (
                <div
                  key={`timer_${timer.timer.id}_${index}`}
                  className="mb-2 md:mb-3 w-full overflow-hidden flex flex-col"
                >
                  <ErrorBoundary>
                    {isNotSmall ? (
                      <SingleLineTimer
                        timer={timer}
                        type={
                          type === "This Week"
                            ? "This Week"
                            : type === "Today"
                              ? "Today"
                              : type === "No Events"
                                ? "No Events"
                                : "older"
                        }
                      />
                    ) : (
                      <SingleLineTimerMobile
                        timer={timer}
                        type={
                          type === "This Week"
                            ? "This Week"
                            : type === "Today"
                              ? "Today"
                              : type === "No Events"
                                ? "No Events"
                                : "older"
                        }
                      />
                    )}
                  </ErrorBoundary>
                </div>
              ))
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default ToggleTimer;
